import { combineReducers } from "redux";

import appReducer from "./reducers/cashBookingReducer";
import dashboardReducer from "./reducers/dashboardReducer";
import manifestReducer from "./reducers/manifestReducer";
import masterReducer from "./reducers/masterReducer";
import onboardingReducer from "./reducers/onboardingReducer";
import hubReconciliationReducer from "./reducers/hubReconciliationReducer";
import roHubAccessReducer from "./reducers/roHubAccessReducer";
import rtoRequestApprovalsReducer from "./reducers/rtoRequestApprovalsReducer";

const appReducers = combineReducers({
  appReducer,
  dashboardReducer,
  manifestReducer,
  masterReducer,
  onboardingReducer,
  hubReconciliationReducer,
  roHubAccessReducer,
  rtoRequestApprovalsReducer,
});

export default appReducers;
